
import { AxiosRequestConfig } from "axios";
import { SavePatientRequest, SaveWoundInfoRequest, SearchPatientRequest, CheckPatientRequest, AddPatientByEMRCheck ,PatientStatus} from "../redux/slice/patient/patientSlice";
import { CHECK_WOUND_INFO_HAS_IVR_URL, CREATE_PATIENT_URL, GET_PATIENT_LIST_BY_USER_ROLE, SAVE_PATIENT_WOUND_INFO_REQUEST_URL, SEARCH_PATIENT_LIST_URL, CHECK_EXISTING_PATIENT_URL, CHECK_PATIENT_ELIGIBILITY, SAVE_PATIENT_BENEFICATION_SUMMARY_URL, GET_PATIENT_BENEFICATION_SUMMARY_URL, GET_ACTIVE_PATIENT_BENEFICATION_SUMMARY_URL, GET_DOCUMENTS_URL, GET_ACTIVE_PATIENT_BENEFICATION_INSURANCE_SUMMARY_URL, UPDATE_PATIENT_ADDRESS, INACTIVATE_PATIENT_WOUND_INFO_URL,ADD_PATIENT_FROM_EMR, GET_SURGICAL_TEMPLATE_BY_PROVIDER_ID,UPDATE_PATIENT_STATUS, GET_PATIENT_LIST_FOR_FILTER, GET_SURGICAL_TEMPLATE_BY_ID, GET_PRESCRIPTIONS_BY_PATIENT_ID, GET_PRESCRIPTIONS_BY_PRODUCT_ID_AND_PATIENT_ID } from "./URL";
import { http } from "./http";

export const fetchPatientsByUserRole = async () => {
    try {
        const response = await http.get(GET_PATIENT_LIST_BY_USER_ROLE);
        return response;
    } catch (error) {
        throw error;
    }
};

// CS-1300
export const fetchPatientListforFilter = async (skipLoader: boolean = false) => {
    try {
        const response = skipLoader
            ? await http.get(GET_PATIENT_LIST_FOR_FILTER, { headers: { "x-skip-loader": "true" } })
            : await http.get(GET_PATIENT_LIST_FOR_FILTER);
        return response;
    } catch (error) {
        throw error;
    }
};
//
export const patientSearchService = async (patientRequest: SearchPatientRequest) => {
    try {
        const response = await http.post(SEARCH_PATIENT_LIST_URL, patientRequest);
        return response;
    } catch (error) {
        throw error;
    }
};
export const fetchPatientEligibilty = async (pVerifyrequest: any) => {
    try {
        const response = await http.post(CHECK_PATIENT_ELIGIBILITY, pVerifyrequest);
        return response;
    } catch (error) {
        throw error;
    }
};

export const savePatient = async (data: SavePatientRequest) => {
    try {
        const response = await http.post(CREATE_PATIENT_URL, data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const woundInfoIvrAvailability = async (patientId: number) => {
    try {
        const response = await http.get(`${CHECK_WOUND_INFO_HAS_IVR_URL}?patientId=${patientId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const checkPatient = async (data: CheckPatientRequest) => {
    try {
        const response = await http.post(CHECK_EXISTING_PATIENT_URL, data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const saveWoundData = async (woundRequest: SaveWoundInfoRequest) => {
    try {
        const response = await http.post(SAVE_PATIENT_WOUND_INFO_REQUEST_URL, woundRequest);
        return response;
    } catch (error) {
        throw error;
    }
};
//CS-1297 - Start
// export const savePatientBeneficationData = async (patientData:any) => {
//     try {
//         const response = await http.post(SAVE_PATIENT_BENEFICATION_SUMMARY_URL, patientData);
//         return response;
//     } catch (error) {
//         throw error;
//     }
// };
export const savePatientBeneficationData = async (
  patientData: any,
  config: AxiosRequestConfig = {}
) => {
  try {
    const response = await http.post(
      SAVE_PATIENT_BENEFICATION_SUMMARY_URL,
      patientData,
      config
    );
    return response;
  } catch (error) {
    throw error;
  }
};
//CS-1297 - End

export const getPatientBeneficationSummary = async(patientId: string) =>{
    try{
        const response = await http.get(`${GET_PATIENT_BENEFICATION_SUMMARY_URL}?patientId=${patientId}`);
        return response;
    }catch(error){;
        throw error;
    }
}
export const getActivePatientBeneficationSummary = async(patientId: string) =>{
    try{
        const response = await http.get(`${GET_ACTIVE_PATIENT_BENEFICATION_SUMMARY_URL}?patientId=${patientId}`);
        return response;
    }catch(error){;
        throw error;
    }
}
export const getActivePatientBeneficationInsruanceSummary = async(bvsId: string) =>{
    try{
        const response = await http.get(`${GET_ACTIVE_PATIENT_BENEFICATION_INSURANCE_SUMMARY_URL}?bvsId=${bvsId}`);
        return response;
    }catch(error){;
        throw error;
    }
}

export const getPatientDocumentsByDocumentIds = async (patientDocumentIds: number[]) => {
    try {
        const response = await http.get(`${GET_DOCUMENTS_URL}/${patientDocumentIds}`);
        return response;
    } catch (error) {
        throw error;
    }
};
// CS-1158 - START
export const updatepatintAddress = async (patientId: number, patientAddress : any) => {
    try {
        const response = await http.post(`${UPDATE_PATIENT_ADDRESS}/${patientId}`,patientAddress);
        return response;
    } catch (error) {
        throw error;
    }
};
// CS-1158 - END

//CS-1244 - Start
export const addPatientByEmrCheck = async (data:AddPatientByEMRCheck) => {
    try {
        const response = await http.post(ADD_PATIENT_FROM_EMR,data);
        return response;
    } catch (error) {
        throw error;
    }
};
export const getSurgicalTemplateBasedOnProviderId = async (providerId:string|number) => {
    try {
        const response = await http.get(`${GET_SURGICAL_TEMPLATE_BY_PROVIDER_ID}?providerId=${providerId}`);
        return response;
    } catch (error) {
        throw error;
    }
};
//CS-1244 - End||||||| .r2937
// CS-1158 - END=======
// CS-1158 - END

export const inactivateWoundInfo = async (patientId: number) => {
    try {
        const response = await http.post(`${INACTIVATE_PATIENT_WOUND_INFO_URL}/${patientId}`);
        return response;
    } catch (error) {
        throw error;
    }
};
export const updatePatientStatus = async (patientStatusRequest: PatientStatus) => {
    try {
        const response = await http.post(`${UPDATE_PATIENT_STATUS}`,patientStatusRequest);
        return response;
    } catch (error) {
        throw error;
    }
};

export const fetchSurgicalTemplateByTemplateId = async (templateId:number) => {
    try {
        const response = await http.get(`${GET_SURGICAL_TEMPLATE_BY_ID}?templateId=${templateId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const fetchPrescriptionsByPatientId = async (patientId:number) => {
    try {
        const response = await http.get(`${GET_PRESCRIPTIONS_BY_PATIENT_ID}?patientId=${patientId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const fetchPrescriptionsByProductIdAndPatientId = async (patientId:number, productId: number) => {
    try {
        const response = await http.get(`${GET_PRESCRIPTIONS_BY_PRODUCT_ID_AND_PATIENT_ID}?patientId=${patientId}&productId=${productId}`);
        return response;
    } catch (error) {
        throw error;
    }
};